module.exports = __webpack_public_path__ + "static/media/trial1_2.775d67b2.png";